import {Component, inject, OnInit, viewChild} from '@angular/core'
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card'
import {BankIdComponent} from '@sparbanken-syd/sparbanken-syd-bankid'
import {environment} from '../../../environments/environment'
import {ConfigService} from '../../services/config.service'
import {filter, first} from 'rxjs'
import {Router} from '@angular/router'
import {MatButton} from '@angular/material/button'

@Component({
  selector: 'spb-login',
  templateUrl: './login.component.html',
  imports: [
    BankIdComponent,
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    MatButton
  ],
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {

  public bankid = viewChild(BankIdComponent)

  public configService = inject(ConfigService)
  public bankIdUrl = environment.authServiceUrl
  public domain = environment.domain

  private readonly router = inject(Router)

  public ngOnInit() {
    this.configService.accessToken$.pipe(
      filter(Boolean),
      first()
    ).subscribe({
      next: () => {
        this.router.navigate(['/', 'home']).then()
      }
    })
  }

  public start(): void {
    this.bankid()?.startProcess()
  }
}
